export class LoadOutlookAccount {
	static readonly type = '[EmailIntegration] Load Outlook Account';
	constructor(public payload: { userId: string }) {}
}

export class CreateGlobalEmailTemplate {
	static readonly type = '[EmailIntegration] Create Global Email Template';
	constructor(public payload: { template: any }) {}
}
